import { connect } from 'react-redux';
import { setSupplierLedger } from 'redux/modules/invoice/index';
import SupplierLedgerList from './supplier-ledger-list';

function mapStateToProps (state) {
  return {
    supplierLedger: state.invoice.supplierLedger
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setSupplierLedger: (supplierLedger) => dispatch(setSupplierLedger(supplierLedger))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SupplierLedgerList);



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/distribution/supplier-ledger/list/supplier-ledger-list-container.js
 **/